import React, { useState, useEffect } from "react";
import { CustomTab, CustomTabs } from 'components/CustomTab/index'
import { AlertContainer, HeaderText, HeaderSubText, EventCountText, HeaderContainer, AmountItemsContainer } from './style'
import AmountItems from "../AmountItems/AmountItems";
import AlertGrid from "./AlertGrid";
import { useDispatch, useSelector } from "react-redux";
import { getAlertList, resetAlertList } from "redux/actions/alert";
import { ALERT_STATUS, ALERT_TYPE } from "utils/alertHelper";
import { USER_TYPE } from "utils/commonHelper";
import { getUserList } from "redux/actions/travel";
import { FilterButton } from "components/FilterButton";
import { getDefaultPoliceNumberList } from 'redux/actions/DefaultPoliceNumber'
import { GET_ALERT_LIST } from '@jumbo/constant/ActionTypes'
import { io } from 'socket.io-client'
const TabPanel = ({ index, children, tabIndex }) => {
    return (
        <div
            role="tabpanel"
            hidden={tabIndex !== index}
            id={`tabpanel-${index}`} style={{ paddingTop: '0' }}>
            {tabIndex === index && children}
        </div>
    )
}

export default function Alert() {
    const dispatch = useDispatch();
    const [tabIndex, setTabIndex] = useState(localStorage.getItem("alertTab") ? Number(localStorage.getItem("alertTab")) : 0)
    const [activePerPage, setActivePerPage] = useState(10);
    const [activePage, setActivePage] = useState(1);
    const [subdivUser, setSubdivUser] = useState([])
    const [filterList, setFilterList] = useState([])
    const alert_type = `${ALERT_TYPE.TRIGGERED_ALERT},${ALERT_TYPE.DELAYED_ALERT}`
    const currentUser = JSON.parse(localStorage.getItem('profile'))
    const tanent_user = currentUser.user_type === USER_TYPE.TENANT_USER
    const { userList: allUsers } = useSelector(({ TRAVEL }) => TRAVEL)
    const { newListRec, progressListRec, alertList } = useSelector(({ ALERT }) => ALERT)
    const { secSubdivisionUser } = useSelector(({ SUBDIVISION }) => SUBDIVISION);

    useEffect(() => {
        // dispatch(getDefaultPoliceNumberList())
    }, [tabIndex])

    //get subdivisions & police number
    useEffect(() => {
        if (currentUser.user_type === USER_TYPE.TENANT_USER) {
            dispatch(getUserList({ user_type: USER_TYPE.SUBDIVISION_USER, is_pagination: false }))
        }
        // dispatch(getDefaultPoliceNumberList())
    }, []);

    useEffect(() => {
        if (tabIndex === 1) {
            let params = { alert_type, page: 1, limit: 10 }
            localStorage.setItem("tab", tabIndex)
            dispatch(getAlertList({ status: ALERT_STATUS.IN_PROGRESS, alert_type, subdivisions: secSubdivisionUser }))
            // tanent_user && dispatch(getUserList({ user_type: USER_TYPE.SUBDIVISION_USER, is_pagination: false }))
        } else {
            localStorage.setItem("tab", tabIndex)
            dispatch(getAlertList({ status: ALERT_STATUS.RAISED, alert_type, page: 1, limit: 10, subdivisions: secSubdivisionUser }))
            // tanent_user && dispatch(getUserList({ user_type: USER_TYPE.SUBDIVISION_USER, is_pagination: false }))
        }

    }, [])

    useEffect(() => {
        if (allUsers && allUsers.userData && allUsers.userData.length > 0) {
            const opt = allUsers.userData.map((option) => ({ label: `${option.first_name} ${option.last_name}`, id: option._id }))
            setSubdivUser(opt)
        }
    }, [allUsers])

    const handlePageChange = (pageNumber) => {
        setActivePage(pageNumber);
        let params = { alert_type, page: pageNumber, limit: activePerPage }
        if (secSubdivisionUser) params = { alert_type, page: pageNumber, limit: activePerPage, subdivisions: secSubdivisionUser }
        if (tabIndex === 0) {
            dispatch(getAlertList({ status: ALERT_STATUS.RAISED, ...params }))
        } else if (tabIndex === 1) {
            dispatch(getAlertList({ status: ALERT_STATUS.IN_PROGRESS, ...params }))
        }
    }

    const renderGrid = () => {
        return <AlertGrid handlePageChange={handlePageChange} activePage={activePage} activePerPage={activePerPage} tabIndex={tabIndex} />
    }

    const tabList = [
        { title: `Alert New (${alertList && alertList.totalNewAlerts ? alertList.totalNewAlerts : '0'})`, element: renderGrid() },
        { title: `Alerts in progress (${alertList?.totalInProgressAlerts || 0})`, element: renderGrid() },
    ]

    const onTabChange = (e, newValue) => {
        setTabIndex(newValue)
        localStorage.setItem("tab", newValue)
        setActivePage(1)
        setActivePerPage(10)
        setFilterList([])
        // tanent_user && dispatch(getUserList({ user_type: USER_TYPE.SUBDIVISION_USER, is_pagination: false }))
        let params = { alert_type, page: 1, limit: 10 }
        if (secSubdivisionUser) params = { alert_type, page: 1, limit: 10, subdivisions: secSubdivisionUser }
        if (newValue === 0) {
            dispatch(getAlertList({ status: ALERT_STATUS.RAISED, ...params }))
        } else if (newValue === 1) {
            dispatch(getAlertList({ status: ALERT_STATUS.IN_PROGRESS, ...params }))
        }
    }

    const changePerPage = (activePerPage) => {
        setActivePerPage(activePerPage);
        let params = { alert_type, page: 1, limit: activePerPage }
        if (secSubdivisionUser) params = { alert_type, page: 1, limit: activePerPage, subdivisions: secSubdivisionUser }
        if (tabIndex === 0) {
            dispatch(getAlertList({ status: ALERT_STATUS.RAISED, ...params }))
        } else if (tabIndex === 1) {
            dispatch(getAlertList({ status: ALERT_STATUS.IN_PROGRESS, ...params }))
        }
    };

    const onFilter = (label) => () => {
        const list = [...filterList]
        if (label === 'all') {
            setFilterList([])
        } else {
            const idx = list.indexOf(label)
            if (idx > -1) {
                list.splice(idx, 1)
            } else {
                list.push(label)
            }
            setFilterList(list)
        }

        const subdivisions = label === 'all' ? '' : list.length === 1 ? list[0] : list.join(',')

        const params = { alert_type, page: activePage, limit: activePerPage, subdivisions: subdivisions }
        if (tabIndex === 0) {
            dispatch(getAlertList({ status: ALERT_STATUS.RAISED, ...params }))
        } else if (tabIndex === 1) {
            dispatch(getAlertList({ status: ALERT_STATUS.IN_PROGRESS, ...params }))
        }
    }

    return (
        <AlertContainer>
            <HeaderContainer style={{ display: 'block' }}>
                <HeaderText> Alert </HeaderText>
                <HeaderSubText> Latest alert always on top </HeaderSubText>
                <EventCountText> {tabIndex === 0 ? 'New' : 'Ongoing'} events - {tabIndex === 0 ? newListRec : progressListRec} </EventCountText>
            </HeaderContainer>
            {tanent_user && <div style={{ marginBottom: '10px' }}>
                <FilterButton variant={filterList.length ? "outlined" : "contained"} key={`subdiv-all`}
                    style={{
                        backgroundColor: filterList.length ? '' : 'rgb(72, 146, 195)',
                        color: filterList.length ? 'rgb(72, 146, 195)' : 'white'
                    }}
                    onClick={onFilter('all')}>
                    {'All'}</FilterButton>
                {subdivUser && subdivUser.map((user, index) => <FilterButton
                    style={{
                        backgroundColor: filterList.indexOf(user.id) > -1 ?
                            'rgb(72, 146, 195)' : '', color: filterList.indexOf(user.id) > -1 ? 'white' : 'rgb(72, 146, 195)'
                    }}
                    variant={filterList.indexOf(user.id) > -1 ? "contained" : "outlined"} key={`subdiv-${index}`} onClick={onFilter(user.id)}>
                    {user.label}</FilterButton>)}
            </div>}
            <CustomTabs value={tabIndex} onChange={onTabChange} aria-label="" twoColors={true} isBlueFirst={true}>
                {tabList.map((tab, index) => <CustomTab key={`tab-${index}`} label={tab.title} id={`tab-${index}`} twoColors={true} isBlueFirst={true} />)}
                <AmountItemsContainer style={{ width: '70%' }}>
                    <AmountItems changePerPage={changePerPage} activePerPage={activePerPage} />
                </AmountItemsContainer>
            </CustomTabs>
            {tabList.map((tab, index) => <TabPanel key={`tabpanel-${index}`} index={index} tabIndex={tabIndex}>{tab.element}</TabPanel>)}
        </AlertContainer>
    );
}
